import { initListingAddressSearch } from '../shared/listing-autocomplete';
import { initInvitationPhotos } from './photos';
import { addressLabel } from '../shared/listing-address-label';
import { createListingLocationMap } from '../shared/listing-location-map';

const copy = document.querySelector('[data-copy-link]');
copy?.addEventListener('click', async () => {
    const input = document.querySelector('[data-copy-source]');
    try { await navigator.clipboard.writeText(input.value); copy.textContent = 'Skopiowano'; }
    catch (_) { input.select(); copy.textContent = 'Zaznaczono link — skopiuj go'; }
});
const advertiser = document.querySelector('[data-advertiser-type]');
function updateBusiness() {
    const section = document.querySelector('[data-business-identity]'); if (!section || !advertiser) return;
    section.hidden = advertiser.value === 'private'; section.querySelectorAll('[data-business-field]').forEach(field => { field.required = !section.hidden; });
}
advertiser?.addEventListener('change', updateBusiness); updateBusiness();
const invitationForm = document.querySelector('[data-invitation-form]');
if (invitationForm) initInvitationPhotos(invitationForm);
const container = document.querySelector('[data-invitation-map]');
if (container && window.maplibregl) {
    const form = document.querySelector('[data-invitation-form]');
    const status = document.querySelector('[data-location-status]');
    const options = document.querySelector('[data-location-options]');
    const exact = JSON.parse(container.dataset.exact || '{}');
    const hint = exact.lat != null ? exact : JSON.parse(container.dataset.hint || '{}');
    const hasHint = hint.lat != null && hint.lng != null && Number.isFinite(Number(hint.lat)) && Number.isFinite(Number(hint.lng));
    let marker, sequence = 0, controller;
    const map = createListingLocationMap(container, hasHint ? [Number(hint.lng), Number(hint.lat)] : [19.1451, 51.9194], hasHint ? 15 : 6, selectPoint);
    let outline = {type:'FeatureCollection',features:[]};
    function showOutline(geometry = null) {
        outline = {type:'FeatureCollection',features:geometry ? [{type:'Feature',properties:{},geometry}] : []};
        map.getSource('invitation-selection')?.setData(outline);
    }
    // The selection takes the page accent (portal department) instead of a fixed colour.
    const accent = getComputedStyle(container).getPropertyValue('--ms-accent').trim() || 'currentColor';
    map.on('load', () => {
        map.addSource('invitation-selection', {type:'geojson',data:outline});
        map.addLayer({id:'invitation-selection-fill',type:'fill',source:'invitation-selection',paint:{'fill-color':accent,'fill-opacity':.2}});
        map.addLayer({id:'invitation-selection-line',type:'line',source:'invitation-selection',paint:{'line-color':accent,'line-width':3}});
    });
    function setField(name, value) { form.elements.namedItem(name).value = value; }
    function resetSelection() {
        showOutline();
        setField('target_type', 'punkt'); setField('dzialka_id', ''); setField('budynek_id', '');
        setField('lat', ''); setField('lng', ''); form.elements.namedItem('location_confirmed').checked = false;
    }
    function addChoice(label, point, target = null) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ms-chip'; button.textContent = label; button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
            options.querySelectorAll('button').forEach(b => { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            button.classList.add('is-active'); button.setAttribute('aria-pressed', 'true');
            resetSelection(); setField('lat', String(point[1])); setField('lng', String(point[0]));
            if (target) { setField('target_type', target.type); setField(target.type === 'dzialka' ? 'dzialka_id' : 'budynek_id', String(target.id)); }
            showOutline(target?.geometry);
            button.focus();
            status.textContent = `Wybrano: ${label}. Potwierdź lokalizację poniżej.`;
        });
        options.append(button);
    }
    async function selectPoint(point) {
        const version = ++sequence; controller?.abort(); controller = new AbortController();
        resetSelection(); options.replaceChildren(); status.textContent = 'Sprawdzam działkę i budynek w tym miejscu…';
        if (!marker) marker = new window.maplibregl.Marker().setLngLat(point).addTo(map);
        else marker.setLngLat(point);
        addChoice('Wybierz wskazany punkt', point);
        const url = new URL(container.dataset.locationUrl, location.origin);
        url.searchParams.set('lat', point[1]); url.searchParams.set('lng', point[0]);
        try {
            const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error();
            const data = await response.json();
            if (version !== sequence) return;
            for (const item of data.items || []) addChoice(item.label, point, item);
            if (!form.elements.namedItem('lat').value) status.textContent = 'Wybierz działkę, budynek albo wskazany punkt.';
        } catch (error) {
            if (error.name !== 'AbortError' && version === sequence) status.textContent = 'Nie udało się odczytać obiektów. Możesz wybrać dokładny punkt lub kliknąć mapę ponownie.';
        }
    }
    document.querySelector('[data-select-map-center]')?.addEventListener('click', () => { const center = map.getCenter(); selectPoint([center.lng, center.lat]); });
    if (exact.lat != null && exact.lng != null && ['dzialka', 'budynek', 'punkt'].includes(exact.target_type)) {
        setField('target_type', exact.target_type); setField('lat', exact.lat); setField('lng', exact.lng);
        setField('dzialka_id', exact.dzialka_id || ''); setField('budynek_id', exact.budynek_id || '');
        marker = new window.maplibregl.Marker().setLngLat([Number(exact.lng), Number(exact.lat)]).addTo(map);
        status.textContent = 'Sprawdź wybraną lokalizację i potwierdź ją poniżej. Możesz też wybrać inne miejsce.';
    }
    form.addEventListener('submit', (event) => {
        if (event.submitter?.value === 'photos') return;
        if (!form.elements.namedItem('lat').value) { event.preventDefault(); status.textContent = 'Najpierw kliknij mapę i wybierz działkę, budynek albo punkt.'; container.scrollIntoView({ block: 'center' }); }
    });
    const search = document.querySelector('[data-location-search]');
    const results = document.querySelector('[data-location-search-results]');
    initListingAddressSearch({
        input: search, results, url: search.dataset.searchUrl,
        onSelect: item => {
            ++sequence; controller?.abort(); resetSelection(); options.replaceChildren();
            marker?.remove(); marker = null;
            search.value = addressLabel(item);
            map.flyTo({ center: [Number(item.lng), Number(item.lat)], zoom: 17 });
            status.textContent = 'Kliknij dokładne położenie nieruchomości na mapie.';
        },
    });
}

const feedback = document.querySelector('[data-invitation-error]:not([hidden]), [data-claim-sent]');
feedback?.focus();

invitationForm?.addEventListener('submit', event => {
    if (event.submitter?.value === 'photos' || event.defaultPrevented || !invitationForm.checkValidity()) return;
    const submit = invitationForm.querySelector('[data-claim-submit]');
    submit.disabled = true; submit.classList.add('is-loading'); submit.textContent = 'Wysyłamy link potwierdzający…';
    invitationForm.setAttribute('aria-busy','true');
});

// Readiness checklist in the aside: e-mail, confirmed location, saved photos
// and the three consents, mirrored on the hero stepper.
const readiness = document.querySelector('[data-readiness]');
if (readiness && invitationForm) {
    const emailInput = invitationForm.querySelector('[data-readiness-email]');
    const locationInput = invitationForm.querySelector('[data-readiness-location]');
    const consentInputs = Array.from(invitationForm.querySelectorAll('[data-readiness-consent]'));
    const photosMissing = invitationForm.querySelector('[data-photos-required]');
    const setItem = (key, ready, missingText) => {
        const state = readiness.querySelector(`[data-readiness-item="${key}"] [data-readiness-state]`);
        if (!state) return;
        state.textContent = ready ? 'Gotowe' : missingText;
        state.classList.toggle('ms-status--success', ready);
        state.classList.toggle('ms-status--warning', !ready);
    };
    const setStep = (key, ready) => document.querySelector(`[data-readiness-step="${key}"]`)?.classList.toggle('is-done', ready);
    const update = () => {
        const email = Boolean(emailInput && emailInput.value.trim() && emailInput.checkValidity());
        const location = Boolean(locationInput && locationInput.checked && invitationForm.elements.namedItem('lat').value);
        const photos = Boolean(photosMissing && photosMissing.hidden);
        const consents = consentInputs.filter(input => input.checked).length;
        setItem('email', email, 'Do uzupełnienia');
        setItem('location', location, 'Do uzupełnienia');
        setItem('photos', photos, 'Do uzupełnienia');
        setItem('consents', consents === consentInputs.length, `${consents} z ${consentInputs.length}`);
        setStep('location', email && location);
        setStep('photos', photos);
        setStep('consents', consents === consentInputs.length);
        const done = [email, location, photos, consents === consentInputs.length].filter(Boolean).length;
        const count = readiness.querySelector('[data-readiness-count]');
        if (count) count.textContent = `${done} z 4`;
        const progress = readiness.querySelector('[data-readiness-progress]');
        if (progress) {
            progress.setAttribute('aria-valuenow', String(done));
            progress.querySelector('span').style.width = `${done * 25}%`;
        }
    };
    invitationForm.addEventListener('input', update);
    invitationForm.addEventListener('change', update);
    if (photosMissing) new MutationObserver(update).observe(photosMissing, { attributes: true, attributeFilter: ['hidden'] });
    update();
}
